import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useContext, useStore, watch } from '@nuxtjs/composition-api'
import ModalPorter from '~/components/base/ModalPorter/ModalPorter.vue'
import GeneralButton from '~/components/base/GeneralButton/GeneralButton.vue'
import amplitudeTracker from '~/composeables/amplitudeTracker/amplitudeTracker'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportFalsePositive',
  setup(__props) {

const { $apiClient } = useContext()
const store = useStore()
const { tracker } = amplitudeTracker()

const showModal = ref(false)
const reportedUrl = ref(false)
const showSuccess = ref(false)
const companyId = computed(() => store.getters['access/getCompanyId'])
const reportFalsePositiveData = computed(() => store.getters['ui/getInitReportings'])

watch(() => reportFalsePositiveData.value, () => {
  if (reportFalsePositiveData.value && reportFalsePositiveData.value.url && reportFalsePositiveData.value.group) {
    showModal.value = true
    tracker('FSC: Open report false positive modal')
  }
})

const sendReport = async () => {
  try {
    const repo = await $apiClient.getRepository('crawler')
    await repo.setCheckStatus(companyId.value, {
      check_type: reportFalsePositiveData.value.group,
      check_status: 'false_positive',
      url: reportFalsePositiveData.value.url
    })
    tracker('FSC: false positive reported')
    reportedUrl.value = true
  } catch (err) {
    console.error(err)
    showModal.value = false
  }
}

watch(() => reportedUrl.value, () => {
  if (reportedUrl.value) {
    showSuccess.value = true
    setTimeout(() => {
      showModal.value = false
      reportedUrl.value = false
      showSuccess.value = false
      store.dispatch('ui/setInitReporting', null)
    }, 2000)
  }
})

return { __sfc: true,$apiClient, store, tracker, showModal, reportedUrl, showSuccess, companyId, reportFalsePositiveData, sendReport, ModalPorter, GeneralButton }
}

})